import React, { memo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from './Logo';
import Navigation from './Navigation';
import Search from './Search';
import { useExhibitions } from '../hooks/useExhibitions';
import { useSearch } from '../hooks/useSearch';
import { useExhibitionContext } from '../contexts/ExhibitionContext';

const Header: React.FC = memo(() => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSelectedExhibition } = useExhibitionContext();
  
  // Get exhibitions data
  const { exhibitions } = useExhibitions({ limit: 50 });
  
  // Get search functionality
  const { search, results: searchResults, isSearching } = useSearch();

  // Determine current view from route
  const getCurrentView = () => {
    const path = location.pathname;
    if (path === '/') return 'homepage';
    if (path === '/exhibition') return 'exhibition';
    if (path.startsWith('/artist/')) return 'artist';
    return 'homepage';
  };

  const handleViewChange = (viewName: string, artistSlug?: string, exhibition?: any) => {
    // Scroll to top when changing views
    window.scrollTo({ top: 0, behavior: 'smooth' });

    switch (viewName) {
      case 'homepage':
        navigate('/');
        break;
      case 'exhibition':
        if (exhibition) {
          setSelectedExhibition(exhibition);
        }
        navigate('/exhibition');
        break;
      case 'artist':
        if (artistSlug) {
          navigate(`/artist/${artistSlug}`);
        }
        break;
      default:
        navigate('/');
    }
  };

  const handleLogoClick = () => {
    // Scroll to top when clicking logo
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/');
  };

  return (
    <header className="header">
      <div className="header-container">
        <Logo onLogoClick={handleLogoClick} />
        <Navigation 
          currentView={getCurrentView()}
          onViewChange={handleViewChange}
          exhibitions={exhibitions}
        />
        <Search 
          onSearch={search}
          searchResults={searchResults}
          isSearching={isSearching}
        />
      </div>
    </header>
  );
});

Header.displayName = 'Header';

export default Header;